<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.clear')" :icon="'mdi-backspace'"
    :color="'error'" :disabled="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "ClearStorageBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {
    };
  },

  methods: {
    async action() {
      const token = localStorage.getItem('token');
      localStorage.clear();
      if (token) {
        localStorage.setItem('token', token);
      }
      window.location.reload();
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
